






























































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import ImportantDates from "@/components/home/ImportantDates.vue";
import Chairmen from "@/components/home/Chairmen.vue";
import OrganizingCommittee from "@/components/home/OrganizingCommittee.vue";

import Topics from "@/components/home/Topics.vue";
import InvitedSpeakers from "@/components/home/InvitedSpeakers.vue";
import ScientificCommittee from "@/components/home/ScientificCommittee.vue";
import Publication from "@/components/home/Publication.vue";
import Programme from "@/components/home/Programme.vue";
import Venue from "@/components/home/Venue.vue";
import Sponsors from "../components/home/Sponsors.vue";
import LoadingOverlay from "../components/shared/LoadingOverlay.vue";
import { allTopics } from "../graphql/topics";
import { allCommitteeMembers, invitedSpeakers } from "../graphql/members";
import { allContent } from "../graphql/content";
import { me } from "../graphql/auth";
import { allConferences } from "../graphql/conference";
import MemberCard from "@/components/home/MemberCard.vue";
import { ITopic } from "@/models/Topic.model";

@Component({
  components: {
    ImportantDates,
    Chairmen,
    OrganizingCommittee,
    Topics,
    InvitedSpeakers,
    ScientificCommittee,
    Publication,
    Programme,
    Venue,
    Sponsors,
    MemberCard,
    LoadingOverlay,
  },
  apollo: {
    allTopics() {
      return { query: allTopics, skip: true, variables: { conference: "" } };
    },
    allCommitteeMembers() {
      return {
        query: allCommitteeMembers,
        skip: true,
        variables: { conference: "" },
      };
    },
    invitedSpeakers() {
      return {
        query: invitedSpeakers,
        skip: true,
        variables: { conference: "" },
      };
    },
    allContent() {
      return { query: allContent, skip: true, variables: { conference: "" } };
    },
    allConferences() {
      return {
        query: allConferences,
        skip: true,
      };
    },
    me() {
      return { query: me, skip: true, variables: { conference: "" } };
    },
  },
})
export default class PastEvent extends Vue {
  conference = this.$router.currentRoute.query.id;
  async getTopics() {
    this.$apollo.queries.allTopics.setVariables({
      conference: this.conference,
    });
    this.$apollo.queries.allTopics.skip = false;
    await this.$apollo.queries.allTopics.refetch();
  }

  async getContent() {
    this.$apollo.queries.allContent.setVariables({
      conference: this.conference,
    });
    this.$apollo.queries.allContent.skip = false;
    await this.$apollo.queries.allContent.refetch();
  }
  async getConferences() {
    this.$apollo.queries.allConferences.skip = false;
    await this.$apollo.queries.allConferences.refetch();
  }

  async getAllCommittees() {
    this.$apollo.queries.allCommitteeMembers.setVariables({
      conference: this.conference,
    });
    this.$apollo.queries.allCommitteeMembers.skip = false;
    await this.$apollo.queries.allCommitteeMembers.refetch();
  }

  async getInvitedSpeakers() {
    this.$apollo.queries.invitedSpeakers.setVariables({
      conference: this.conference,
    });
    this.$apollo.queries.invitedSpeakers.skip = false;
    await this.$apollo.queries.invitedSpeakers.refetch();
  }

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }

  get showNav() {
    return this.$store.getters.showNav;
  }
  // topics
  index = 0;

  next() {
    this.index++;
  }

  previous() {
    if (this.index == 0) this.index = this.topics.length;
    this.index--;
  }

  displayModal = false;
  topic: ITopic = {};

  displayTopic(topic: ITopic) {
    this.topic = topic;
    this.displayModal = true;
  }

  closeTopic() {
    this.displayModal = false;
  }
  // topics

  isLoading = false;

  carousel: any = null;
  about: any = null;
  importantDates: any = null;
  publication: any = null;
  programme: any = null;
  venue: any = null;
  sponsors: any = null;
  chairman: any = null;
  honoraryChairman: any = null;
  coChairman: any = null;
  scientificCommitteeChairman: any = null;
  topics: any = null;
  organizingCommittee: any = null;
  scientificCommittee: any = null;
  invitedSpeakersList: any = null;

  async beforeMount() {
    this.isLoading = true;

    await this.getContent();

    // @ts-ignore
    this.carousel = this.allContent.find(
      // @ts-ignore
      (content) => content.section == "carousel"
    );
    // @ts-ignore
    this.about = this.allContent.find((content) => content.section == "about");
    // @ts-ignore
    this.importantDates = this.allContent.find(
      //@ts-ignore
      (content) => content.section == "dates"
    );
    // @ts-ignore
    this.importantDates = this.allContent.find(
      //@ts-ignore
      (content) => content.section == "publication"
    );
    // @ts-ignore
    this.programme = this.allContent.find(
      //@ts-ignore
      (content) => content.section == "programme"
    );
    // @ts-ignore
    this.venue = this.allContent.find(
      //@ts-ignore
      (content) => content.section == "venue"
    );
    // @ts-ignore
    this.sponsors = this.allContent.find(
      //@ts-ignore
      (content) => content.section == "sponsors"
    );

    await this.getAllCommittees();

    // @ts-ignore
    this.chairman = this.allCommitteeMembers.find(
      // @ts-ignore
      (member) => member.isChairman == true
    );

    // @ts-ignore
    this.honoraryChairman = this.allCommitteeMembers.find(
      // @ts-ignore
      (member) => member.isHonoraryChairman == true
    );

    // @ts-ignore
    this.coChairman = this.allCommitteeMembers.find(
      // @ts-ignore
      (member) => member.isCoChairman == true
    );

    // @ts-ignore
    this.scientificCommitteeChairman = this.allCommitteeMembers.find(
      // @ts-ignore
      (member) => member.isScientificCommitteeChairman == true
    );

    //@ts-ignore
    this.organizingCommittee = this.allCommitteeMembers.filter(
      // @ts-ignore
      (member) =>
        member.isInternationalCommittee == true ||
        member.isLocalCommittee == true
    );

    //@ts-ignore
    this.scientificCommittee = this.allCommitteeMembers.filter(
      // @ts-ignore
      (member) => member.isScientificCommittee == true
    );

    await this.getInvitedSpeakers();

    //@ts-ignore
    this.invitedSpeakersList = this.invitedSpeakers;
    //@ts-ignore
    console.log(this.invitedSpeakersList);

    await this.getTopics();
    // @ts-ignore
    this.topics = this.allTopics;

    this.isLoading = false;
  }
}
